export default __webpack_public_path__ + "static/media/pic3.8012f21e.jpg";